import { useMutation } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { ID } from 'utils/types'
import toast from 'react-hot-toast'

const createBillingSession = async (orgId: ID) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v1/stripe/customer_billing_portal_session`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({
        org_id: orgId,
        return_url: `https://linqapp.com/admin/${orgId}/dashboard`, // return URL
      }),
    }
  )
  handleErrors(response)
  const json: { billing_portal_session_url: string } = await response.json()
  return json.billing_portal_session_url
}

const useBillingSession = (onSuccess?: (url: string) => void) => {
  return useMutation(
    ({ orgId }: { orgId: ID }) => createBillingSession(orgId),
    {
      onSuccess: async (url) => {
        try {
          await navigator.clipboard.writeText(url)
          toast.success('Link created and copied to clipboard!', {
            icon: '✅',
          })
          onSuccess?.(url)
        } catch (error) {
          console.error('Failed to copy to clipboard:', error)
          toast.error('Failed to copy link to clipboard')
        }
      },
      onError: (error) => {
        console.error('Failed to create billing session:', error)
        toast.error('Failed to create billing session. Please try again.')
      },
    }
  )
}

export default useBillingSession
